import {
  AnalysisResultType,
  DatasetAnalysisPayload,
  OutputGrid
} from "@/types/dataset";
import { ScoringOptions } from "@/types/spatial";
import { CustomError } from "@/utils/errors";

type RunSpatialAnalysisAction = {
  dataset_count: number;
  output_type:
    | AnalysisResultType.TYPE_SITE_PROFILING
    | AnalysisResultType.TYPE_GRID;
  scoring_option: ScoringOptions;
  grid_type?: string;
  grid_level?: number;
  output_mode?: string;
  custom_catchment_type?: string;
  custom_catchment_radius?: number;
  z_score_intercept?: number;
  error?: CustomError;
};
export const buildSpatialAnalysisTracker = (
  data: DatasetAnalysisPayload & { error?: CustomError }
) => {
  const trackedData: RunSpatialAnalysisAction = {
    dataset_count: data.datasets.length,
    output_type: data.output?.output_type,
    scoring_option: data.output?.scoring_option,
    error: data?.error
  };
  if (data.output?.z_score) {
    trackedData.z_score_intercept = data.output.z_score.intercept;
  }
  const gridConfig = (data.output as OutputGrid)?.grid_config;
  if (gridConfig) {
    trackedData.grid_type = gridConfig.grid_type;
    trackedData.grid_level = gridConfig.level;

    if (gridConfig.output_mode) {
      trackedData.output_mode = gridConfig.output_mode;
    }
    if (gridConfig.custom_catchment) {
      trackedData.custom_catchment_type = gridConfig.custom_catchment.type;
      trackedData.custom_catchment_radius =
        gridConfig.custom_catchment.radius_m;
    }
  }
  return trackedData;
};
